import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spinner } from "@heroui/react";
import { useQueryClient } from "@tanstack/react-query";
import { fetchAuthCallback, USER_QUERY_KEY, useUserStore } from "@/entities/user";

export const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setUser = useUserStore((s) => s.setUser);
  const processedRef = useRef(false);

  useEffect(() => {
    if (processedRef.current) return;
    processedRef.current = true;

    const code = searchParams.get("code");
    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    fetchAuthCallback(code)
      .then((res) => {
        if (res?.user) {
          setUser(res.user);
          queryClient.setQueryData(USER_QUERY_KEY, res.user);
        }
        navigate("/", { replace: true });
      })
      .catch((err) => {
        console.error("Ошибка обработки callback:", err);
        navigate("/login", { replace: true });
      });
  }, [searchParams, navigate, queryClient, setUser]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center">
      <Spinner size="lg" />
      <p className="mt-4 text-xs text-neutral-400">Авторизация...</p>
    </div>
  );
};
